import React from "react";

const Image = () => {
    return (
        <div
            data-name="Image"
            className="w-full relative text-center items-center"
        >
            <img
                className="w-full fade-in"
                src="https://storage.googleapis.com/hublot_assets/prototype/hero_background.png"
                alt="Latest Product"
            ></img>
        </div>
    );
};

export default Image;
